import { render, staticRenderFns } from "./FileServiceOther.vue?vue&type=template&id=32b85ff8&scoped=true&"
import script from "./FileServiceOther.vue?vue&type=script&lang=js&"
export * from "./FileServiceOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b85ff8",
  null
  
)

export default component.exports